import React from 'react'
import "./SelectsStyles.css"

import BoraBora from '../../assets/borabora.jpg'
import BoraBora2 from '../../assets/borabora2.jpg'
import KeyWest from '../../assets/keywest.jpg'
import Maldives from '../../assets/maldives.jpg'
import Maldives2 from '../../assets/maldives2.jpg'
import Maldives3 from '../../assets/maldives3.jpg'


import SelectsImg from '../SelectsImg/SelectsImg'

function Selects() {
    return (
        <div name='views' className='selects'>
            <div className="container">
                <SelectsImg bgImg={BoraBora} text='Bora Bora' />
                <SelectsImg bgImg={BoraBora2} text='Emerald Bay' />
                <SelectsImg bgImg={KeyWest} text='Key West' />
                <SelectsImg bgImg={Maldives} text='Maldives' />
                <SelectsImg bgImg={Maldives2} text='KeyWest' />
                <SelectsImg bgImg={Maldives3} text='The Caribbean' />
            </div>
        </div>
    )
}

export default Selects